import React, { useState, useEffect } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import { ModalStyled } from './styled'
import ActionDialog from '../action-dialog'
import { InputField, CustomAlert, InfoChip } from '../../atoms'
import { tokens } from '../../../assets/tokens'
import { useAppContext } from '../../../context/appContext'
import { ALERT_LEVEL } from '../../../config/constants'

const ModalEditPhase = ({ open, handleClose, i18n, onSubmitEditPhase, initialValue, itemId, allPhasesData }) => {
  const { createAlert } = useAppContext();
  const [phase, setPhase] = useState(initialValue);
  const [phaseStates, setPhaseStates] = useState([]);
  const [alert, setAlert] = useState({ message: '', severity: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [originalPhase, setOriginalPhase] = useState('');

  useEffect(() => {
    if (open && initialValue) {
      setIsOpen(true);
      setOriginalPhase(initialValue);
      setPhase(initialValue);
    }
  }, [open, initialValue]);

  useEffect(() => {
    if (isOpen && typeof phase === 'string' && phase.trim() !== '' && allPhasesData) {
      const selectedPhase = allPhasesData.find(fase => fase.name === phase);

      if (selectedPhase) {
        setPhaseStates(selectedPhase.status_candidates || []);
      }
    }

  }, [isOpen, phase, allPhasesData]);

  const resetModalValues = () => {
    if (isOpen) {
      setIsOpen(false);
      setPhase(originalPhase);
      setPhaseStates(originalPhase.status_candidates || []);
    }
  };

  const onChangePhase = e => {
    setPhase(e.target.value);
  }

  const onClickSubmit = async (e) => {
    e.preventDefault();


    const isPhaseDuplicate = allPhasesData.some(existingPhase => existingPhase.name === phase && existingPhase.id !== itemId);

    if (isPhaseDuplicate) {
      setAlert({ message: i18n.phases_states.alertPhaseExists, severity: 'error' });
      setShowAlert(true);

      setTimeout(() => {
        setShowAlert(false);
      }
      , 2000);
      return;
    }

    const updatedPhase = { id: itemId, name: phase, status_candidates: phaseStates };
  
    // Spinner en Guardar mientras dura la petición; se cierra y sale el toast solo si va bien
    try {
      await onSubmitEditPhase(updatedPhase);
      handleClose();
      createAlert(i18n.phases_states.updatedPhase, ALERT_LEVEL.SUCCESS);
    } catch (error) {
      setAlert({ message: i18n.phases_states.errorUpdatedPhase, severity: 'error' });
      setShowAlert(true);

      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  }; 
    
  const onCloseModal = () => {
    handleClose();
    resetModalValues();
  };

  return (
    <ActionDialog
      open={open}
      title={i18n.phases_states.modalEditPhaseTitle}
      onClose={onCloseModal}
      onConfirm={onClickSubmit}
      cancelLabel={i18n.phases_states.buttonCancel}
      confirmLabel={i18n.phases_states.buttonSave}
      maxWidth="sm"
      fullWidth
      disableBackdropClose
    >
      <ModalStyled>
        <form onSubmit={onClickSubmit}>
          <div className="formField">
            <label>{i18n.phases_states.labelPhase}</label>
            <InputField placeholder={i18n.phases_states.placeholderPhase} value={phase} onChange={onChangePhase} />
          </div>
          <div className="formField">
            <label>{i18n.phases_states.titleState}</label>
            <div className="wrapper-tags">
              {phaseStates.length > 0 ? (
                phaseStates.map((status) => (
                  <InfoChip
                    key={status.id}
                    label={status.name}
                    fillColor={status.color || undefined}
                    textColor={status.color ? tokens.color.text.onDark : undefined}
                  />
                ))
              ) : (
                <InfoChip label={i18n.phases_states.chipUnAssigned} />
              )}
            </div>
          </div>
          {showAlert && <CustomAlert severity={alert.severity} message={alert.message} />}
        </form>
      </ModalStyled>
    </ActionDialog>
  )
}

const enharce = compose(withI18n)

export default enharce(ModalEditPhase)
